<template>
  <div class="btn" :style="{ backgroundImage: `url(${bg})`}">
    <div class="button" @click="gotoWeb">
      <img :src="downloadBtn" alt="">
    </div>
  </div>
</template>

<script>
import downloadBtn from '@/assets/images/download-btn.png'
import { Toast } from 'vant'

export default {
  name: 'DownloadApp',
  props: {
    bg: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      downloadBtn
    }
  },
  methods: {
    gotoWeb() {
      if (!this.disabled) {
        window.location.href = 'http://jacqxsycgis.starnetah.com/app_download_5/index.html'
      } else {
        Toast('此页面只用于分享，快去邀请好友购车吧')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.btn {
  position: fixed;
  bottom: 0;
	left: 0;
	right: 0;
	padding: rem(32);
  background-position: bottom;
  .button {
    height: rem(104);
    border-radius: rem(8);
    text-align: center;
    font-size: rem(32);
    line-height: rem(104);
    img{
      width: 100%;
      display: block;
    }
  }
}
</style>
